var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.0002C8 3.55837 8.35817 3.2002 8.8 3.2002H20.8C21.6834 3.2002 22.4 3.91677 22.4 4.8002V20.8002H9.6C9.15817 20.8002 8.8 20.442 8.8 20.0002C8.8 19.5584 9.15817 19.2002 9.6 19.2002H20.8V4.8002H8.8C8.35817 4.8002 8 4.44202 8 4.0002Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59998 3.2002H3.19998C2.31598 3.2002 1.59998 3.9162 1.59998 4.8002V20.8002H9.59998V3.2002ZM3.99998 7.2002C3.55838 7.2002 3.19998 6.84179 3.19998 6.4002C3.19998 5.9586 3.55838 5.6002 3.99998 5.6002C4.44158 5.6002 4.79998 5.9586 4.79998 6.4002C4.79998 6.84179 4.44158 7.2002 3.99998 7.2002ZM7.19998 7.2002C6.75838 7.2002 6.39998 6.84179 6.39998 6.4002C6.39998 5.9586 6.75838 5.6002 7.19998 5.6002C7.64158 5.6002 7.99998 5.9586 7.99998 6.4002C7.99998 6.84179 7.64158 7.2002 7.19998 7.2002ZM7.99998 10.4002H3.19998V8.80019H7.99998V10.4002Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.9eea9684079bd2dd24fa0fcf1aef87ee.svg";
export { ForwardRef as ReactComponent };